import _ from 'underscore';

export function update(state, payload) {
    return { ...state, ...payload };
}

function isPartialMatch(needles, haystack) {
    if (!needles || !needles.length) {
        return true;
    }
    if (!haystack || !haystack.length) {
        return true;
    }
    needles = _.uniq(needles.sort(), true);
    haystack = _.uniq(haystack.sort(), true);
    return needles.some(function (needle) {
        return haystack.indexOf(needle) !== -1;
    });
}

function isPriceMatch(needle, product) {
    if (!needle) {
        return true;
    }
    if (needle === 'free') {
        return product.price_key === 'free';
    }
    if (needle === 'on_sale') {
        return product.on_sale;
    }
    if (needle === 'trial_pay') {
        return product.trial_pay_link;
    }
    return true;
}

function isTextMatch(needles, product) {
    if (!needles || !needles.length) {
        return true;
    }
    var normalizeText = function(text) {
        return text.replace(/-.,/, ' ').trim().toLowerCase();
    };
    var haystack = normalizeText((product.product_name || '') + ' ' + (product.short_description || ''));
    return normalizeText(needles).split(/\s+/).every(function (needle) {
        return haystack.indexOf(needle) !== -1;
    });
}

function filterProducts(products, filter) {
    if (!Object.keys(filter).length) {
        return products;
    }

    return products.filter(function (product) {
        return (
            isPartialMatch(filter.category, product.category) &&
            isPartialMatch(filter.modality, product.modality) &&
            isTextMatch(filter.search, product) &&
            isPriceMatch(filter.price, product)
        );
    });
}

export function filter(state, payload) {
    const filteredProducts = filterProducts(state.products, payload.filters);
    return {
        ...state,
        inputs: payload.inputs,
        filter: payload.filters,
        filteredProducts: filteredProducts,
    };
}



// WEBPACK FOOTER //
// ./app/reducers/catalog.js